import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { getRouteIsComplete } from '@src/store/modules/route-handler.store';
import { useRouteHandlerStore } from '@src/store';

export default function useRouteGuard() {
	const router = useRouter();
	const pathname = usePathname();
	const { routes, routesInitialized } = useRouteHandlerStore((store) => store);

	useEffect(() => {
		if (!routesInitialized) {
			router.replace('/');
			return;
		}

		const normalizedPathname = pathname?.endsWith('/') ? pathname.slice(0, -1) : pathname ?? '';

		const currentRouteIndex = routes.findIndex((route) => {
			const normalizedRoute = route.route.endsWith('/') ? route.route.slice(0, -1) : route.route;
			return normalizedPathname === normalizedRoute || normalizedPathname.endsWith(normalizedRoute);
		});

		if (currentRouteIndex === -1) return;

		const firstIncompleteIndex = routes.findIndex((route) => !getRouteIsComplete(route.route));

		// All routes complete — silently suppress (e.g. confirmation page)
		if (firstIncompleteIndex === -1) return;

		if (currentRouteIndex > firstIncompleteIndex) {
			router.replace(routes[firstIncompleteIndex].route);
		}
	}, [routesInitialized, pathname, routes, router]);
}
